// extracted by mini-css-extract-plugin
module.exports = {"list":"e_bA","hero":"e_cA"};